export enum FileDataPrefix {
    jpeg = 'image/jpeg',
    jpg = 'image/jpg',
    pbix = 'application/pbix',
    pdf = 'application/pdf',
    png = 'image/png',
    pptx = 'application/pptx',
    xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}
